import { getAllModulesInitActions, getSectionLayoutInitAction } from './common';

export function getHomeSectionInitActions(responseData) {
  const commentV2 =
    responseData.session.features &&
    responseData.session.features.includes('comment_v2');
  const isMobile =
    responseData.session.device && responseData.session.device.isMobile;
  let commentMaxDepth = 3;
  if (commentV2) {
    commentMaxDepth = isMobile ? 2 : 4;
  }
  const params = { commentMaxDepth };
  return [
    getSectionLayoutInitAction(responseData, 'home'),
    ...getAllModulesInitActions(responseData, params),
  ].filter(action => action);
}
